module.exports = __webpack_public_path__ + "54ef0f7ba1355411413d1b182456de2e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/calibre/calibre.ttf
// module id = 1521
// module chunks = 0